(() => {
  'use strict';

  const localizeProductLinks = () => {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    document.querySelectorAll('.ofk-product-story a[href]').forEach((link) => {
      const raw = link.getAttribute('href');
      if (!raw || !raw.startsWith('/products/')) return;
      const destination = new URL(raw, window.location.origin);
      link.setAttribute(
        'href',
        `${normalizedRoot}${destination.pathname.replace(/^\//u, '')}${destination.search}${destination.hash}`
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localizeProductLinks, { once: true });
  } else {
    localizeProductLinks();
  }
})();
